import { MouseEventHandler, ReactNode } from 'react';
import { cn } from '../../utils';

type BadgeProps = {
    children: ReactNode;
    className?: string | object;
    variant?:
        | 'gray'
        | 'red'
        | 'orange'
        | 'green'
        | 'blue-gray'
        | 'purple'
        | 'blue';
    onClick?: MouseEventHandler<HTMLButtonElement>;
};

const variants = {
    gray: {
        container: 'alli-bg-gray-100 alli-text-gray-800',
        hoverOn: 'hover:alli-bg-gray-400',
        svgColor: 'alli-stroke-gray-700',
    },
    red: {
        container: 'alli-bg-red-100 alli-text-red-900',
        hoverOn: 'hover:alli-bg-red-200',
        svgColor: 'alli-stroke-red-300',
    },
    orange: {
        container: 'alli-bg-orange-100 alli-text-orange-700',
        hoverOn: 'hover:alli-bg-orange-200',
        svgColor: 'alli-stroke-orange-500',
    },
    green: {
        container: 'alli-bg-green-100 alli-text-green-1000',
        hoverOn: 'hover:alli-bg-green-200',
        svgColor: 'alli-stroke-green-700',
    },
    ['blue-gray']: {
        container: 'alli-bg-blue-gray-100 alli-text-blue-gray-700',
        hoverOn: 'hover:alli-bg-blue-gray-200',
        svgColor: 'alli-stroke-blue-gray-400',
    },
    purple: {
        container: 'alli-bg-purple-100 alli-text-purple-1000',
        hoverOn: 'hover:alli-bg-[#CCC5ED]',
        svgColor: 'alli-stroke-[#8B85AB]',
    },
    blue: {
        container: 'alli-bg-blue-100 alli-text-blue-600',
        hoverOn: 'hover:alli-bg-[#C1E3FF]',
        svgColor: 'alli-stroke-blue-300',
    },
};
export default function Badge({
    children,
    onClick,
    className,
    variant = 'blue',
}: BadgeProps) {
    return (
        <span
            data-testid="Badge"
            className={cn(
                variants[variant].container,
                'alli-inline-flex alli-items-center alli-gap-x-0.5 alli-rounded-md alli-px-2 alli-py-1 alli-text-xs alli-font-medium',
                className,
            )}>
            {children}
            {onClick && (
                <button
                    onClick={onClick}
                    type="button"
                    className={cn(
                        variants[variant].hoverOn,
                        'alli-group alli-relative -alli-mr-1 alli-h-3.5 alli-w-3.5 alli-rounded-sm',
                    )}>
                    <span className="alli-sr-only">Remove</span>
                    <svg
                        viewBox="0 0 14 14"
                        className={cn(
                            'alli-h-3.5 alli-w-3.5 ',
                            variants[variant].svgColor,
                        )}>
                        <path d="M4 4l6 6m0-6l-6 6" />
                    </svg>
                    <span className="alli-absolute -alli-inset-1" />
                </button>
            )}
        </span>
    );
}
